/**
 * Static benchmark reference rates for the earnings chart.
 *
 * These are approximate reference lines (FDIC savings, T-bill, Aave USDC)
 * for visual comparison. They don't need a backend endpoint — the rates
 * are updated manually when they materially change.
 */

import type { BenchmarkId, BenchmarkPoint, BenchmarkSeries } from "./mockData";

const N_DAYS = 365;

function buildSeries(base: number, drift: number): BenchmarkPoint[] {
    const now = Date.now();
    const DAY_MS = 86_400_000;
    const pts: BenchmarkPoint[] = [];
    for (let i = 0; i < N_DAYS; i++) {
        const wobble = Math.sin(i / 9) * drift;
        pts.push({
            timestampMs: now - (N_DAYS - 1 - i) * DAY_MS,
            ratePct: base + wobble
        });
    }
    return pts;
}

export const STATIC_BENCHMARKS: Record<BenchmarkId, BenchmarkSeries> = {
    fdic: {
        id: "fdic",
        label: "FDIC savings average",
        caption: "FDIC national average",
        available: true,
        points: buildSeries(0.41, 0.02)
    },
    tbill: {
        id: "tbill",
        label: "3-month T-bill",
        caption: "US Treasury DGS3MO",
        available: true,
        points: buildSeries(5.21, 0.08)
    },
    aave: {
        id: "aave",
        label: "Aave USDC supply",
        caption: "Aave v3 USDC market",
        available: true,
        points: buildSeries(4.53, 0.25)
    }
};
